import { Field, useForm } from "react-final-form";
import FilesContainer from "component/filesContainer/FilesContainer";
import { PickerPersonalDataFilesType } from "pages/pickers/types";
import { DETAIL_PICKER_TAG, VALIDATION_REGEX } from "utils/constants";
import { PersonalDataProps } from "./types";
import "../detailPicker.scss";
import { useTranslation } from "react-i18next";
import "./i18n";
import moment from "moment";
import {
  AutoComplete,
  InformativeNotification,
  MultiSelectInput,
  TextInput,
} from "@pickit/pickit-components";

const PersonalData = ({
  isActivePicker,
  regions,
  identificationType,
  testId,
  workzones,
  fetchingWorkzones,
  hasComeFromCode,
  hasComeFrom,
  phoneNumber,
  name,
  pickerTermsStatus,
  ...props
}: PersonalDataProps) => {
  const { t } = useTranslation("personal");
  const { mutators, getFieldState } = useForm();
  const regionValue = getFieldState("region")?.value;

  
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";
    return moment(dateString).format("DD/MM/YYYY");
  };
  return (
    <div
      data-testId={testId}
      id={testId}
      className="container-detail-picker-fluid card-container"
    >
      <div className="container-detail-picker-row">
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-name"}
            id={testId + "-name"}
            name="personalData.name"
            label={t("nameLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("namePlaceholder")}
            maxLength={49}
            onClick={() => mutators.upper("personalData.name")}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-surname"}
            id={testId + "-surname"}
            name="personalData.surname"
            label={t("surnameLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("surnamePlaceholder")}
            maxLength={49}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-identification-number"}
            id={testId + "-identification-number"}
            name="personalData.identification.number"
            disabled
            label={t("identifierLabel", {
              identification: identificationType || "-",
            })}
            component={TextInput}
            className="Admin-Pickers-input disabled"
            placeholder="-"
            showClearIcon={false}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-email"}
            id={testId + "-email"}
            name="personalData.email"
            label={t("emailLabel")}
            component={TextInput}
            disabled
            className="Admin-Pickers-input disabled"
            placeholder="-"
            showClearIcon={false}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-birth"}
            id={testId + "-birth"}
            name="personalData.dateOfBirth"
            label={t("birthdateLabel")}
            component={TextInput}
            disabled
            className="Admin-Pickers-input"
            placeholder="-"
            showClearIcon={false}
          />
        </div>
        <div className="container-detail-picker-col-xs-8 container-detail-picker-col-sm-4 container-detail-picker-col-xl-3">
          <Field
            type="text"
            testId={testId + "-area-number"}
            id={testId + "-area-number"}
            name="personalData.phone.areaNumber"
            label={t("areaCodeLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("areaCodePlaceholder")}
            maxLength={5}
            pattern={VALIDATION_REGEX.regNumber}
          />
        </div>
        <div className="container-detail-picker-col-xs-16 container-detail-picker-col-sm-4 container-detail-picker-col-xl-3">
          <Field
            type="text"
            testId={testId + "-phone"}
            id={testId + "-phone"}
            name="personalData.phone.number"
            label={t("phoneLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("phonePlaceholder")}
            maxLength={10}
            pattern={VALIDATION_REGEX.regNumber}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            name="region"
            testId={testId + "-region"}
            id={testId + "-region"}
            label={t("regionLabel")}
            placeholder={t("regionPlaceholder")}
            onChange={mutators.setWorkzones}
            options={regions}
            isValueObject
            showClearIcon={false}
          >
            {(props: any) => <AutoComplete {...props} />}
          </Field>
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
          <Field
            name="desiredWorkzones"
            testId={testId + "-workzones"}
            label={t("workzoneLabel")}
            placeholder={t("workzonePlaceholder")}
            disabled={workzones?.length === 0 && !regionValue}
            options={workzones.map((workzone) => ({
              ...workzone,
              id: workzone.name,
            }))}
          >
            {(props: any) => (
              <MultiSelectInput
                {...props}
                allText={t("global:allF")}
                loading={fetchingWorkzones}
              />
            )}
          </Field>
        </div>
        {hasComeFrom && (
          <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
            <Field
              type="text"
              testId={testId + "-comeFrom"}
              id={testId + "-comeFrom"}
              name="personalData.comeFrom"
              label={t("comeFromLabel")}
              component={TextInput}
              disabled
              className="Admin-Pickers-input"
              placeholder="-"
              showClearIcon={false}
            />
          </div>
        )}
        {hasComeFromCode && (
          <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
            <Field
              type="text"
              testId={testId + "-comeFromCode"}
              id={testId + "-comeFromCode"}
              name="personalData.comeFromCode"
              label={t("comeFromCodeLabel")}
              component={TextInput}
              className="Admin-Pickers-input"
              placeholder={t("comeFromCodePlaceholder")}
              maxLength={12}
              pattern={VALIDATION_REGEX.lettersAndNumbers}
            />
          </div>
        )}
        {!pickerTermsStatus?.needsUpdate && (
          <>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
              <Field
                type="text"
                testId={testId + "-terms-version"}
                id={testId + "-terms-version"}
                name="term.userVersion.version"
                label={t("termsVersionLabel")}
                defaultValue={pickerTermsStatus?.userVersion?.version}
                component={TextInput}
                className="Admin-Pickers-input"
                placeholder="-"
                disabled
                showClearIcon={false}
              />
            </div>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
              <Field
                type="text"
                testId={testId + "-terms-date"}
                id={testId + "-terms-date"}
                name="term.userVersion.acceptedAt"
                label={t("termsDateLabel")}
                format={(value) => formatDate(value)}
                component={TextInput}
                className="Admin-Pickers-input"
                disabled
                showClearIcon={false}
              />
            </div>
          </>
        )}
      </div>
      {pickerTermsStatus?.needsUpdate && (
        <div className="margin-bottom-50 container-detail-picker-col-xs-24 container-detail-picker-col-sm-12 container-detail-picker-col-xl-12">
          <InformativeNotification
            dataTestId={testId + "-terms-outdated"}
            title={t("termsOutdatedTitle") || "Términos y condiciones desactualizados"}
            body={
              pickerTermsStatus.needsUpdate &&
                t("termsRequiredVersionMessage", {
                  currentVersion: pickerTermsStatus.currentVersion.version,
                  lastUpdate: formatDate(pickerTermsStatus.currentVersion.uploadedAt)
                })
            }
            showClearIcon={false}
            status="warning"
          />
        </div>
      )}
      <FilesContainer<PickerPersonalDataFilesType>
        testId={testId + "-files"}
        id={testId + "-files"}
        {...props}
        showDeleteIcon={!isActivePicker}
        names={DETAIL_PICKER_TAG}
      />
    </div>
  );
};

export default PersonalData;
